<div class="p-3 w-100">
  <div class="row">
    <div class="col-md-6 col-12">
      <div class="d-flex flex-column">
        <label class="block text-900 font-medium mb-2 ms-label-view ssssss"><i class="pi pi-book mx-2"></i>{{'days before' |
          translator}}</label>
        <input type="text" [(ngModel)]="days" placeholder="placeholder" (ngModelChange)="updateDateLimits()" pInputText
          class="w-full mb-3 ms-input-view" />
      </div>
    </div>
    <div class="col-md-6 col-12 ppp-dropdown">
      <div class="d-flex flex-column">
        <label class="block text-900 font-medium mb-2 ms-label-view dddddd"><i class="pi pi-book mx-2"></i>Dropdown</label>
        <p-calendar class="pppp-calander w-100" appendTo="body" [(ngModel)]="date" dateFormat="dd-mm-yy"
          (onSelect)="dateValidate($event)" [readonlyInput]="false">
          <ng-template pTemplate="date" let-date1>
            <span [ngStyle]="{
                  textDecoration: disableDates(date1)
                    ? 'line-through'
                    : 'inherit'
                }">{{ date1.day }}</span>
          </ng-template>
        </p-calendar>
      </div>
    </div>
    <div class="d-flex justify-content-center w-100 mt-5">
      <button class="py-2 v4-btn-every" (click)="submit()"><i class="pi pi-check v4-ml-2"></i>Submit</button>
    </div>
  </div>
</div>

<p-toast />